/**
 * Magic.Lap theme toggle — cycles light → dark → auto → light.
 * Drop this anywhere in the layout (typically the header/nav).
 *
 * Uses only CSS variables so it already looks correct in all three states.
 */

import { useTheme, type Theme } from '../context/ThemeContext';

const STATE: Record<Theme, { icon: string; label: string; title: string }> = {
  light: { icon: '☀', label: 'فاتح',    title: 'الوضع الفاتح — اضغط للتبديل للغامق' },
  dark:  { icon: '◑', label: 'غامق',    title: 'الوضع الغامق — اضغط للتبديل للتلقائي' },
  auto:  { icon: '⬡', label: 'تلقائي',  title: 'تلقائي (حسب النظام) — اضغط للتبديل للفاتح' },
};

interface ThemeToggleProps {
  /** Extra Tailwind classes to pass to the button. */
  className?: string;
  /** Show text label alongside the icon (default true). */
  showLabel?: boolean;
}

export function ThemeToggle({ className = '', showLabel = true }: ThemeToggleProps) {
  const { theme, cycle } = useTheme();
  const { icon, label, title } = STATE[theme];

  return (
    <button
      type="button"
      onClick={cycle}
      title={title}
      aria-label={title}
      className={[
        'inline-flex items-center gap-1.5',
        'h-8 px-3 rounded-brand-md touch-target',
        'text-xs font-medium font-tajawal',
        'border border-default',
        'text-secondary hover:text-primary',
        'hover:bg-surface-hover',
        'transition-colors duration-base ease-standard',
        'select-none',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <span aria-hidden="true" className="text-sm leading-none">
        {icon}
      </span>
      {showLabel && <span>{label}</span>}
    </button>
  );
}
